import { render, staticRenderFns } from "./OnlineResolutionDetailPage.vue?vue&type=template&id=70246ca6&"
import script from "./OnlineResolutionDetailPage.vue?vue&type=script&lang=ts&"
export * from "./OnlineResolutionDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports